import React from 'react'

import { useForm } from './_load/FormLoader'
import { useModalData } from '../../../components/modals/ModalsContext'
import FormReplyLoader from './_load/FormReplyLoader'
import ModalHeader from './ModalHeader'
import Replies from './Replies'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const Content = ({ initialNumber }) => {
  const { repliesCount } = useForm()
  const { number: initialNumberFromModal } = useModalData() || {}
  initialNumber = initialNumber || initialNumberFromModal
  const [number, setNumber] = React.useState(initialNumber)

  const goToNext = () => {
    let newNumber = number + 1
    if (newNumber > repliesCount) newNumber = 1
    setNumber(newNumber)
  }
  const goToPrev = () => {
    let newNumber = number - 1
    if (newNumber < 1) newNumber = repliesCount
    setNumber(newNumber)
  }

  return (
    <FormReplyLoader
      number={number}
      uncontrolledChildren={<ModalHeader number={number} goToNext={goToNext} goToPrev={goToPrev} />}
    >
      <Separator weight={8} />
      <Replies number={number} />
    </FormReplyLoader>
  )
}

export default Content
